import { RootState, ThumbnailSearchModel, ThumbnailState, ThumbnailViewModel } from '@/types';
import { GetterTree } from 'vuex';

export const getters: GetterTree<ThumbnailState, RootState> = {
  getThumbnail: (state) => (thumbnailSearchModel: ThumbnailSearchModel): ThumbnailViewModel | undefined => {
    return state.thumbnails.find(
      (x: ThumbnailViewModel) =>
        x.documentId === thumbnailSearchModel.documentId &&
        x.cabinetId === thumbnailSearchModel.cabinetId &&
        x.page === thumbnailSearchModel.page
    );
  },
  getAllThumbnails(state) {
    return state.thumbnails;
  }
};
